/* eslint-disable */
// @ts-nocheck

import React from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import Select from '../../../components/forms/Select'
import Button from '../../../components/misc/Button'
import { useAppSelector } from '../../../store/hooks'

interface ConvertToOrderModalInterface {
  orderId: number
  setConvertToOrderWithAreaModal: React.Dispatch<React.SetStateAction<boolean>>
  TransformPreReceiptIntoReceipt: Function
  isFetching: boolean
}
export const ConvertToOrderModal = ({
  orderId,
  setConvertToOrderWithAreaModal,
  TransformPreReceiptIntoReceipt,
  isFetching,
}: ConvertToOrderModalInterface) => {
  //React Hook Form-----------------------------------------------------------------------
  const { handleSubmit, control, watch } = useForm()

  const onSubmit: SubmitHandler<Record<string, string | number>> = async (
    data
  ) => {
    const areaId = watch('areaId')

    TransformPreReceiptIntoReceipt!(
      orderId,
      areaId
        ? {
            areaSalesId: areaId,
          }
        : {},
      () => setConvertToOrderWithAreaModal(false)
    )
  }

  //Areas ------------------------------------
  const { areas } = useAppSelector((state) => state.nomenclator)

  const stockAreas =
    areas
      ?.filter((area) => area.type === 'SALE')
      .map(({ id, name }) => {
        return { id, name }
      }) || []

  return (
    <form>
      <h2 className="mb-6 text-xl font-semibold">Convertir a factura</h2>
      <div className="flex w-full flex-col gap-2">
        <div className="col-span-2 py-1">
          <Select
            control={control}
            data={stockAreas}
            label="Seleccione un área de venta para registrar la nueva orden *"
            name="areaId"
            rules={{ required: 'Este campo es requerido' }}
          />
        </div>

        <div className="mt-4 flex w-full justify-end gap-3">
          <div>
            <Button
              action={handleSubmit(onSubmit)}
              color="slate-600"
              disabled={isFetching}
              loading={isFetching}
              name="Aceptar"
              type="button"
            />
          </div>
        </div>
      </div>
    </form>
  )
}
